export default __webpack_public_path__ + "static/media/timesquare_trafic.34bf2337.jpg";